module.exports = __webpack_public_path__ + "img/Rose_Marker.333de9f4.svg";